import { useSanityProduct } from 'hooks/product/useSanityProduct';

import { ReviewedProductInfo } from './ReviewedProductInfo';

export interface ProductInfoFromSlugProps {
  review?: never;
  slug: string;
  isLight?: boolean;
}

export function ProductInfoFromSlug({
  slug,
  ...props
}: ProductInfoFromSlugProps) {
  const sanityProduct = useSanityProduct(slug);

  return (
    sanityProduct && <ReviewedProductInfo product={sanityProduct} {...props} />
  );
}
